export default __webpack_public_path__ + "static/media/tandem-logo.e80c1cde.svg";